export const parseSentTime = (sent: string | null) => {
  if (!sent) return 0;
  const parsed = Date.parse(sent);
  return isNaN(parsed) ? 0 : parsed;
};
